import Command from './Command';
import common from '../common';
import MorphCommand from './MorphCommand';

export default class RepeatCommand extends Command {
	constructor() {
		super('ui_function_repeat_bg_9slice');

		this.type = Command.TYPE_LOOP;
		this.direction = null;
		this.commands = [];
		this.options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
		this.variableActive = true;
		this.active = false;
		this.currentMoveIndex = 0;
		this._isChild = false;
		this._tempheight = 0;
		this._extended = false;

		this.signals.onVariableTouch = new P3.utils.MiniSignal();
		this.signals.onResize = new P3.utils.MiniSignal();
		this.signals.onPlace = new P3.utils.MiniSignal();

		this.init();
	}

	init() {
		this.ui.off('pointerdown');
		this.ui.off('pointerup');
		this.ui.off('pointerupoutside');
		this.ui.off('pointermove');

		this.ui.destroy();
		this.ui = null;

		this.ui = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_function_repeat_bg_9slice'), 50, 60, 6, 31);

		this.ui.width = common.commandDimensions.width;
		this.ui.height = common.commandDimensions.height;
		this.ui.x = -(this.ui.width >> 1);
		this.ui.y = -(this.ui.height >> 1);

		this._tempheight = this.ui.height;

		this.ui.interactive = true;

		this.addChild(this.ui);

		super.init('GAME.BLOCKS.REPEAT', 'ui_icon_repeat');

		// repostion icon, label, variable
		const newPosition = -(common.commandDimensions.height >> 1) + (this.repeatAlignTop >> 1);

		this.commandIcon.y = newPosition + 6;
		this.commandLabel.y = newPosition - common.commandFontOffset;
		this.variableBackground.y = newPosition;
		this.variableLabel.y = newPosition - common.commandFontOffset + 1;

		this.on('pointertap', (e) => {
			e.stopPropagation();

			if (e.target.parent !== this.parent) {
				if (!this.canChangeVariable) {
					return;
				}
				e.target.parent.signals.onVariableTouch.dispatch(e.target.parent, e);

				return;
			}

			this.signals.onVariableTouch.dispatch(this, e);
		});

		this.variableBackground.visible = this.variableActive;
		this.variableLabel.visible = this.variableActive;

		this.initEvents();
	}

	_onCommandPickup(heldCommand) {
		const index = this.commands.indexOf(heldCommand);

		this.commands.splice(index, 1);

		heldCommand.attached = false;

		// adding it back to the UI container of CommandInterface
		this.parent.parent.addChild(heldCommand);

		this.resize();

		for (const arrayCommand of this.commands) {
			arrayCommand.slotPosition.copy(arrayCommand.position);
		}

		heldCommand.x = 167;
	}

	setText(text) {
		if (!this.variableActive) {
			text = '';
		}

		this.variableLabel.text = `${text}`;
	}

	onPlace() {
		this.resize();
	}

	onCommandRelease(command) {
		this.checkCommand(command);
	}

	checkCommand(heldCommand) {
		if (heldCommand instanceof RepeatCommand) {
			heldCommand.destroy();

			this.resize();

			return;
		}

		if (this.currentMoveIndex < this.commands.length) {
			this.commands.splice(this.currentMoveIndex, 0, heldCommand);
		} else {
			this.commands.push(heldCommand);
		}

		// "indent"
		heldCommand.x = 15;
		heldCommand.parent.removeChild(heldCommand);
		this.addChild(heldCommand);

		heldCommand.interactive = true;
		heldCommand.variable = heldCommand.defaultVariable;
		heldCommand.setText(heldCommand.variable);
		heldCommand.attachedRepeat = this;
		heldCommand.placed = true;

		this._extended = false;
		this._tempheight = this.ui.height;
		this.resize();
		this.signals.onPlace.dispatch(heldCommand);

		for (const arrayCommand of this.commands) {
			arrayCommand.slotPosition.copy(arrayCommand.position);
		}
	}

	onCommandMove(heldCommand, templateCommand) {
		if (this.commands.length <= 0) {
			this.ui.height = 68 + heldCommand.height;

			templateCommand.visible = true;

			const global = this.toGlobal(common.stage);
			templateCommand.y = global.y + 50;

			return;
		}

		this.ui.height = this._tempheight + heldCommand.height - common.commandTopBottomOffset;

		let closest = this.commands[0];
		let closestDistance = Infinity;

		const last = this.commands[this.commands.length - 1];
		const global = heldCommand.toGlobal(new PIXI.Point(0, 0));
		const heldLocal = this.toLocal(global);

		for (const arrayCommand of this.commands) {
			if (arrayCommand.locked) {
				closest = -2;
				continue;
			}
			if (heldLocal.y <= arrayCommand.y) {
				arrayCommand.y = arrayCommand.slotPosition.y + heldCommand.height - common.commandTopBottomOffset;

				const d = arrayCommand.y - heldLocal.y;

				if (d >= 0 && d < closestDistance) {
					templateCommand.y = arrayCommand.y - heldCommand.height + this.y + 10;

					closestDistance = d;

					closest = arrayCommand;
				}
			} else {
				arrayCommand.y = arrayCommand.slotPosition.y;

				if (heldLocal.y > last.y) {
					templateCommand.y = last.y + heldCommand.height + this.y - 10;

					closest = -2;
				}
			}
		}

		let i = this.commands.indexOf(closest);

		if (closest === -2) {
			i = this.commands.length;
		} else {
			i = Math.max(i, 0);
		}

		this.currentMoveIndex = i;
	}

	resize(order = true) {
		if (this.commands.length <= 0) {
			// add 20px to height to make it look prettier
			this.ui.height = common.commandDimensions.height + 20;
			return;
		}

		if (!order) {
			let totalheight = this.commands[this.commands.length - 1].y - this.ui.y + (this.commands[this.commands.length - 1].height >> 1);

			totalheight += common.commandTopBottomOffset;

			this.ui.height = this._tempheight = totalheight;
			return;
		}

		// align 1st command vertically -> this.repeatAlignTop
		this.commands[0].y = this.repeatAlignTop;

		for (let i = 1; i < this.commands.length; i++) {
			this.commands[i].y = this.commands[i - 1].y + (this.commands[i - 1].height >> 1) + (this.commands[i].height >> 1) - common.commandTopBottomOffset;

			if (this.commands[i] instanceof MorphCommand) {
				this.commands[i].y += 2;
			} else if (this.commands[i - 1] && this.commands[i - 1] instanceof MorphCommand) {
				this.commands[i].y -= 2;
			}
		}

		let totalheight = this.commands[this.commands.length - 1].y - this.ui.y + (this.commands[this.commands.length - 1].height >> 1);

		totalheight += this.repeatAlignBottom;

		this.ui.height = this._tempheight = totalheight;
	}

	get extended() {
		return this._extended;
	}

	set extended(v) {
		this._extended = v;
	}
}
